export interface RankingRowWithGap<T> {
  row: T
  /** `true` quando há colocações não exibidas entre esta linha e a anterior. */
  hasGapBefore: boolean
}

/**
 * Os rankings Geral, Escola e Amigos já vêm do backend com a linha do usuário
 * logado anexada ao Top N (`WHERE position <= limit OR id = current_user`),
 * então a lista pode saltar da última colocação do topo direto para a dele.
 * Este helper marca onde esse salto acontece, para a UI sinalizar a lacuna.
 *
 * A comparação é contra a quantidade de linhas anteriores, e não contra a
 * posição anterior: o ranking usa `RANK()`, que pula números em caso de empate
 * (`1, 1, 3`) sem que exista qualquer linha faltando.
 */
export function markRankingGaps<T extends { position: number }>(
  rows: T[]
): RankingRowWithGap<T>[] {
  return rows.map((row, index) => ({
    row,
    hasGapBefore: index > 0 && row.position - 1 > index
  }))
}
